import React from 'react'
import styled from 'styled-components'
import { categories } from './colors'
import { ReactComponent as LibrariesIcon } from 'images/RADicons_Libraries_Dark.svg'
import { ReactComponent as ArtsIcon } from 'images/RADicons_Arts_Culture_Dark.svg'
import { ReactComponent as ParksIcon } from 'images/RADicons_Parks_Trails_Dark.svg'
import { ReactComponent as RegionalIcon } from 'images/RADicons_Regional_Facilities.svg'
import { ReactComponent as TransportIcon } from 'images/RADicons_Transportation_Dark.svg'
import { ReactComponent as MunicipalIcon } from 'images/RADicons_Municipality_Dark.svg'
import { ReactComponent as StadiumIcon } from 'images/RADicons_Stadiums_Dark.svg'

const Category = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid white;
  position: absolute;
  bottom: -16px;
  right: 26px;
  background-color: #888;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  padding: 8px;
  ${({ selected }) =>
    selected &&
    `
      background-color: ${categories[selected]};
    `}

  @media screen and (min-width: 500px) {
    width: 100px;
    height: 100px;
    padding: 8px 12px;
    border-width: 5px;
    bottom: -22px;
  }

  svg {
    width: 100%;
    height: 100%;

    * {
      fill: white;
    }
  }
`

const CategoryIcon = (props) => {
  const { category, sports_checkbox } = props

  return (
    <Category selected={category}>
      {category ? (
        category === 'Libraries' ? (
          <LibrariesIcon />
        ) : category === 'Parks, Trails & Green Spaces' ? (
          <ParksIcon />
        ) : category === 'Arts & Culture' ? (
          <ArtsIcon />
        ) : category === 'Regional, Sports, and Civic Facilities' && sports_checkbox ? (
          <StadiumIcon />
        ) : category === 'Regional, Sports, and Civic Facilities' ? (
          <RegionalIcon />
        ) : category === 'Transit' ? (
          <TransportIcon />
        ) : (
          <MunicipalIcon />
        )
      ) : null}
    </Category>
  )
}

export default CategoryIcon
